import GeneratePassword from './GeneratePassword';

export default GeneratePassword;
